module.exports = __webpack_public_path__ + "img/success.a414634b.png";